import BccRwdRewardsList from 'components/Bcc/BccRwdRewardsList/BccRwdRewardsList';
import { withBccRwdRewardsListProps } from 'viewModel/bcc/bccRwdRewardsList/withBccRwdRewardsListProps';

export default withBccRwdRewardsListProps(BccRwdRewardsList);
